(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-inventory-hero"] && !Shopify.designMode) return;
  try {
    
  class SeInventorySearch extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const next = this.tabs[(i + (event.key === 'ArrowRight' ? 1 : this.tabs.length - 1)) % this.tabs.length];
          this.select(next);
          next.focus();
        });
      });

      const form = this.querySelector('[data-panel="filters"]');
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const query = new URLSearchParams([...new FormData(form)].filter(([, value]) => value)).toString();
        window.location.href = form.querySelector('[data-type]').value + (query ? '?' + query : '');
      });
    }

    select(tab) {
      this.tabs.forEach((t) => {
        const active = t === tab;
        t.setAttribute('aria-selected', active);
        t.tabIndex = active ? 0 : -1;
        this.querySelector('[data-panel="' + t.dataset.tab + '"]').inert = !active;
      });
    }
  }

  if (!customElements.get('se-inventory-search')) customElements.define('se-inventory-search', SeInventorySearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-offer-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.seOc) return;
      root.seOc = true;
      const track = root.querySelector('.se-oc__track');
      const slides = track.children;
      const dots = root.querySelectorAll('.se-oc__dot');
      const n = +root.dataset.count;
      let i = n, busy = 0, frame = 0;

      const step = () => slides[1].offsetLeft - slides[0].offsetLeft;

      function place(anim) {
        track.classList.toggle('is-anim', anim);
        track.style.transform = `translateX(${-i * step()}px)`;
        dots.forEach((d, k) => d.setAttribute('aria-current', k === i % n));
      }

      // Snap from a clone set back into the real set, without animation.
      function settle() {
        clearTimeout(busy);
        busy = 0;
        if (i < n || i >= 2 * n) { i = n + i % n; place(false); }
      }

      // Moves are locked until the slide lands, so fast clicks can't run past the clones.
      // The timeout is a fallback in case transitionend never fires.
      function go(to) {
        if (busy || to === i) return;
        i = to;
        place(true);
        if (reduce) settle();
        else busy = setTimeout(settle, 700);
      }

      track.addEventListener('transitionend', e => { if (e.target === track) settle(); });
      root.querySelectorAll('.se-oc__arrow').forEach(b => b.addEventListener('click', () => go(i + +b.dataset.dir)));
      dots.forEach((d, k) => d.addEventListener('click', () => go(n + k)));

      // Swipe counts only when it is mostly sideways, so scrolling the page never flips a banner.
      let x0 = null, y0 = 0;
      track.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      track.addEventListener('touchend', e => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
      });

      new ResizeObserver(() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => place(false)); }).observe(track);
      place(false);
    }

    const run = () => document.querySelectorAll('.se-oc').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-visit"] && !Shopify.designMode) return;
  try {
    
  {
    const today = new Date().toLocaleDateString('en-US', { weekday: 'long', timeZone: 'America/New_York' });
    document.querySelectorAll('.se-visit [data-day]').forEach((row) => row.classList.toggle('is-today', row.dataset.day === today));
  }

  } catch(e) { console.error(e); }
})();
})();
